import { Type } from 'class-transformer';
import { IsDefined, IsOptional, ValidateNested } from 'class-validator';
import { UserInternationalizationDto } from './user-internationalization.dto';
import { UserNotificationSettingsDto } from './user-notification-settings.dto';

export class UserSettingsDto {
  @ValidateNested()
  @Type(() => UserInternationalizationDto)
  @IsDefined()
  internationalization!: UserInternationalizationDto;

  @ValidateNested()
  @Type(() => UserNotificationSettingsDto)
  @IsOptional()
  notifications?: UserNotificationSettingsDto;
}
